const calculateSize = function (url) {
  return new Promise(function (resolve, reject) {
    const image = document.createElement('img');
    image.addEventListener('load', function (e) {
      resolve({
        width: e.target.width,
        height: e.target.height,
      });
    });

    image.addEventListener('error', function () {
      reject();
    });

    image.src = window.location.href + url;
  });
};

const createMapMarkerHoverToolTip = (tooltipContent, marker, google) => {
  const CustomHoverTitle = function (marker) {
    this._marker = marker;
    this._markerPosition = this._marker.getPosition();

    // This zero-height div is positioned at the bottom of the tip.
    this._tooltipContainerDiv = document.createElement('div');
    this._tooltipContainerDiv.classList.add('map-marker-tooltip__container');
    this._tooltipContainerDiv.insertAdjacentHTML('afterbegin', tooltipContent);

    // Call the OverlayView constructor
    google.maps.OverlayView.call(this);
  };

  CustomHoverTitle.prototype = Object.create(google.maps.OverlayView.prototype);

  /** Called when the popup is added to the map. */
  CustomHoverTitle.prototype.onAdd = function () {
    this.getPanes().floatPane.appendChild(this._tooltipContainerDiv);
  };

  /** Called when the popup is removed from the map. */
  CustomHoverTitle.prototype.onRemove = function () {
    if (this._tooltipContainerDiv.parentElement) {
      this._tooltipContainerDiv.parentElement.removeChild(
        this._tooltipContainerDiv
      );
    }
  };

  /** Called each frame when the popup needs to draw itself. */
  CustomHoverTitle.prototype.draw = async function () {
    const overlayProjection = this.getProjection();
    const markerDivPosition = overlayProjection.fromLatLngToDivPixel(
      this._markerPosition
    );

    // Hide the popup when it is far out of view.
    const display =
      Math.abs(markerDivPosition.x) < 4000 && Math.abs(markerDivPosition.y) < 4000
        ? 'block'
        : 'none';

    // Get iconSize to position tooltip on top of marker
    const iconSizeHeight = await calculateSize(this._marker.getIcon()).then((data) => data.height);

    if (display === 'block') {
      // visible when in correct position of marker
      // the default visibility is "none"
      this._tooltipContainerDiv.style.left = markerDivPosition.x + 'px';
      this._tooltipContainerDiv.style.top = markerDivPosition.y - iconSizeHeight + 'px';
      this._tooltipContainerDiv.style.visibility = 'visible';
    }

    if (this._tooltipContainerDiv.style.display !== display) {
      this._tooltipContainerDiv.style.display = display;
    }
  };

  return new CustomHoverTitle(marker);
};

export default createMapMarkerHoverToolTip;
